"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingMessageDisplay = void 0;
var React = require("react");
var config_1 = require("../../../config");
var BookingMessageDisplay = function (_a) {
    var message = _a.message;
    return (React.createElement("div", { key: message.id, className: "row logistics-message" },
        React.createElement("div", { className: "col-7 logistics-message-author" },
            React.createElement("p", null, message.author_name)),
        React.createElement("div", { className: "col-5 logistics-message-date" },
            React.createElement("p", null, message.date.format(config_1.ISO_DATETIME_FORMAT))),
        React.createElement("div", { className: "col logistics-message-body" },
            React.createElement("p", null, message.comment))));
};
exports.BookingMessageDisplay = BookingMessageDisplay;
